import { fundingHqFetch } from './fundingApi';

function agencyQuery(agencyId) {
  return new URLSearchParams({ agency_id: agencyId }).toString();
}

export async function fetchIdentityProfiles(clientId, agencyId) {
  const data = await fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/identity-profiles?${agencyQuery(agencyId)}`,
  );
  return data.profiles ?? [];
}

export async function createIdentityProfile(clientId, agencyId, payload) {
  return fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/identity-profiles?${agencyQuery(agencyId)}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
  );
}

export async function updateIdentityProfile(clientId, agencyId, profileId, payload) {
  return fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/identity-profiles/${encodeURIComponent(profileId)}?${agencyQuery(agencyId)}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
  );
}

export async function deleteIdentityProfile(clientId, agencyId, profileId) {
  return fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/identity-profiles/${encodeURIComponent(profileId)}?${agencyQuery(agencyId)}`,
    { method: 'DELETE' },
  );
}

export async function markIdentityProfilePrimary(clientId, agencyId, profileId) {
  return fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/identity-profiles/${encodeURIComponent(profileId)}/mark-primary?${agencyQuery(agencyId)}`,
    { method: 'POST' },
  );
}

export async function duplicateIdentityProfile(clientId, agencyId, profileId) {
  return fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/identity-profiles/${encodeURIComponent(profileId)}/duplicate?${agencyQuery(agencyId)}`,
    { method: 'POST' },
  );
}

export async function revealClientSsn(clientId, agencyId, { profileId, applicationId }) {
  return fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/audit/ssn-reveal?${agencyQuery(agencyId)}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        profile_id: profileId || undefined,
        application_id: applicationId || undefined,
      }),
    },
  );
}

export async function auditClientSsnCopy(clientId, agencyId, { profileId, applicationId, copyFull }) {
  return fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/audit/ssn-copy-full?${agencyQuery(agencyId)}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        profile_id: profileId || undefined,
        application_id: applicationId || undefined,
        copy_full: Boolean(copyFull),
      }),
    },
  );
}
